import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import { StatusBarItem } from './StatusBarItem.view';

import type { StatusBarTask } from '../../types/common.types';

const useStyle = makeStyles(() => {
  return {
    statusBar: {
      width: '100%',
      position: 'absolute',
      bottom: '1rem',
      // @ts-ignore
      left: (props) => (props.collapsed ? '1rem' : 0),
    },
  };
});

export const StatusBarItems: React.FC<{
  collapsed: boolean;
  tasks: StatusBarTask[];
}> = ({ collapsed = false, tasks }) => {
  const classes = useStyle({ collapsed });

  return (
    <div className={classes.statusBar}>
      {tasks.map((task) => (
        <StatusBarItem
          show={task.value}
          text={task.caption}
          tooltip={task.tooltip}
          key={task.id}
          testId={task.testId}
        />
      ))}
    </div>
  );
};
